export const TITLE_CREATE_TEST_NEW = 'TITLE_CREATE_TEST_NEW';
export const TITLE_CREATE_TEST_EDIT = 'TITLE_CREATE_TEST_EDIT';
